import Icon1 from "./images/sidebar/icon-1.svg";
import Icon2 from "./images/sidebar/icon-2.svg";
import Icon3 from "./images/sidebar/icon-3.svg";
import Icon4 from "./images/sidebar/icon-4.svg";
import Icon5 from "./images/sidebar/icon-5.svg";
import Icon6 from "./images/sidebar/icon-6.svg";
import Icon7 from "./images/sidebar/icon-7.svg";
import Icon8 from "./images/sidebar/icon-8.svg";
import Icon9 from "./images/sidebar/icon-9.svg";
import Icon10 from "./images/sidebar/icon-10.svg";
import Icon11 from "./images/sidebar/icon-11.svg";
import Icon12 from "./images/sidebar/icon-12.svg";
import PosthumousIcon from "./images/posthumous-icon.svg";
import MilestoneIcon from "./images/milestone-icon.svg";

export interface MenuItem {
    id: number;
    title: string;
    path: string;
    icon?: string; // Image path for icons
    action?: string; 
}

export const menuItems: MenuItem[] = [
    { id: 1, title: "Dashboard", path: "/dashboard", icon: Icon1 },
    { id: 2, title: "Customers", path: "/users", icon: Icon2 },
    { id: 3, title: "Orders", path: "/orders", icon: Icon3 },
    { id: 4, title: "Posthumous Gifts", path: "/posthumousgifts", icon: PosthumousIcon },
    { id: 5, title: "Milestone Gifts", path: "/milestonegifts", icon: MilestoneIcon },
    { id: 6, title: "Gift Management", path: "/gift-management", icon: Icon4 },
    { id: 7, title: "Discount Codes", path: "/referral-discount", icon: Icon5 },
    // { id: 8, title: "Discount Code Details", path: "/discount-codes-details", icon: Icon5 },
    { id: 9, title: "Transactions", path: "/transactions", icon: Icon6 },
    { id: 10, title: "Subscription Plans", path: "/subscription-plans", icon: Icon7 },
    // { id: 11, title: "Subscription Details", path: "/subscriptions", icon: Icon7 },
    // { id: 12, title: "Reporting & Analytics", path: "/reporting", icon: Icon8 },
    // { id: 13, title: "CMS Pages", path: "/cms", icon: Icon9 },
    { id: 14, title: "Support", path: "/support", icon: Icon10 },
    // { id: 15, title: "Settings", path: "/settings", icon: Icon11 },
    { id: 16, title: "Logout", path: '#', icon: Icon12, action: 'logout' },
    // { id: 4, title: "Logout", path: "/", icon: Icon11 },
];